/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Profession from './component/professionType'
import { Spin } from 'antd'
import { fetchProfessionList } from '../../api/clubProfession'

class ClubProfession extends React.Component {
  static defaultProps = {
    totalType: [],
  }
  state = {
    loading: true,
  }

  // 获取业务分组列表
  getProfessionList = () => {
    fetchProfessionList()
      .then((res) => {
        this.setState({
          professionList: res.data,
        })
      })
      .then((res) => {
        this.setState({ loading: false })
      })
  }

  componentDidMount() {
    this.getProfessionList()
    // this.props.fetchClubProfession().then((res) => {
    //   this.setState({ loading: false })
    // })
    // this.props.fetchTotalType()
  }

  render() {
    const { professionList, totalType } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Profession
            list={this.state.professionList}
            totalType={totalType}
            fetchDeleteProfession={this.props.fetchDeleteProfession}
            fetchAddFirmType={this.props.fetchAddFirmType}
            getProfessionList={this.getProfessionList}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    professionList: state.getClubProfession.professionList,
    totalType: state.getClubProfession.totalType,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubProfession))



// WEBPACK FOOTER //
// ./src/containers/ClubProfession/index.js